import React, { useEffect, useState, useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import generalRequest from "../../../request/generalRequest";
import companyBasedRequest from "../../../request/companyBasedRequest";
import "./attributesModal.css";

const AttributesModal = ({ open, onClose, shopId, shopData, setShopData }) => {
	const { language, userData} = useContext(CombinedContext);
	const [allAttributes, setAllAttributes] = useState([]);
	const [selected, setSelected] = useState([]);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!open) return;

		(async () => {
			try {
				// Load all attribute objects
				const resp = await companyBasedRequest.getAllAttributes();
				setAllAttributes(resp.attributes || []);

				// Load selected IDs
				const activeIds = shopData.attributes?.map((a) => a.attributeId) || [];
				setSelected(activeIds);
			} catch (err) {
				console.error("Failed to load attributes:", err);
			}
		})();
	}, [open, shopData]);

	const toggleSelect = (id) => {
		setSelected((prev) =>
			prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
		);
	};

	const handleSave = async () => {
		try {
			setSaving(true)
			const result = await companyBasedRequest.updateShopAttributes(shopId, selected, userData.cognitoTokens.AccessToken);

			// Hydrate updated attributes back into the UI state
			setShopData((prev) => ({
				...prev,
				attributes: result.shop.attributes || []
			}));
		} catch (err) {
			console.error("Failed to save attributes:", err);
		} finally {
            setSaving(false);
        }


		onClose();
	};

	if (!open) return null;

	return (
		<div className="sf-attrmd-overlay" onClick={onClose}>
			<div className="sf-attrmd-modal" onClick={(e) => e.stopPropagation()}>
				{/* Header */}
				<div className="sf-attrmd-header">
					<h2 className="sf-attrmd-title">
						{language === "es" ? "Atributos del negocio" : "Shop Attributes"}
					</h2>

					<button className="sf-attrmd-close" onClick={onClose}>
						✕
					</button>
				</div>

				{/* Grid */}
				<div className="sf-attrmd-body">
					{allAttributes.length === 0 ? (
						<p className="sf-attrmd-empty">No attributes found.</p>
					) : (
						<div className="sf-attrmd-grid">
							{allAttributes.map((attr) => {
								const isSelected = selected.includes(attr.attributeId);

								return (
									<div
										key={attr.attributeId}
										className={`sf-attrmd-item ${isSelected ? "is-selected" : ""}`}
										onClick={() => toggleSelect(attr.attributeId)}
									>
										{/* Icon */}
										{attr.icon ? (
											<img src={attr.icon} alt="" className="sf-attrmd-icon" />
										) : (
											<div className="sf-attrmd-icon-placeholder" />
										)}

										{/* Label */}
										<div className="sf-attrmd-label">
											{language === "es" ? attr.nameES : attr.nameEN}
										</div>
									</div>
								);
							})}
						</div>
					)}
				</div>

				{/* Footer */}
				<div className="sf-base-footer">
					<button className="btn ghost" onClick={onClose}>
						{translations[language].calendar.editor.cancel}
					</button>
					<button className="btn" onClick={handleSave} disabled={saving}>
						{saving ? translations[language].calendar.editor.saving : translations[language].calendar.editor.save}
					</button>
				</div>
			</div>
		</div>
	);
};

export default AttributesModal;
